import React from 'react';
import Input from '../../../components/forms/Input';

const AddressFields = ({ onInput, errors, data }) => (
    <React.Fragment>
        <div className="ckp-admin-grid-row">
            <div className="ckp-admin-grid-column">
                <Input
                    errorMessage={errors.address1}
                    label="Address Line 1"
                    name="address1"
                    onChange={onInput}
                    value={data.address1}
                />
            </div>
            <div className="ckp-admin-grid-column">
                <Input
                    errorMessage={errors.address2}
                    label="Address Line 2"
                    name="address2"
                    onChange={onInput}
                    value={data.address2}
                />
            </div>
            <div className="ckp-admin-grid-column">
                <Input
                    errorMessage={errors.postalCode}
                    label="Postal Code"
                    name="postalCode"
                    onChange={onInput}
                    value={data.postalCode}
                />
            </div>
            <div className="ckp-admin-grid-column">
                <Input errorMessage={errors.city} label="City" name="city" onChange={onInput} value={data.city} />
            </div>
        </div>
        <div className="ckp-admin-grid-row">
            <div className="ckp-admin-grid-column">
                <Input
                    errorMessage={errors.stateProvince}
                    label="State / Province"
                    name="stateProvince"
                    onChange={onInput}
                    value={data.stateProvince}
                />
            </div>
            <div className="ckp-admin-grid-column">
                <Input
                    errorMessage={errors.country}
                    label="Country"
                    name="country"
                    onChange={onInput}
                    value={data.country}
                />
            </div>
        </div>
    </React.Fragment>
);

export default AddressFields;
